import { CountryEnum } from '@/core/country/country.enum';

export const countriesRequireState = [
  CountryEnum.UNITED_STATES.toString(),
  CountryEnum.CANADA.toString(),
];
